import React from "react";
import { ColorRing } from "react-loader-spinner";

const CallLogsTable = ({ callLogs, onEdit, onFollowUp, selectedLog, setSelectedLog, isLoading }) => {

  if (isLoading) {
    return (
      <div className="flex justify-center items-center">
        <ColorRing
          visible={isLoading}
          height="100"
          width="100"
          ariaLabel="color-ring-loading"
          wrapperStyle={{}}
          wrapperClass="color-ring-wrapper"
          colors={['#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C']}
        />
      </div>
    );
  }


  return (
    <table className="w-full mt-4 border-collapse border border-gray-300">
      <thead>
        <tr className="bg-gray-300">
          <th className="border p-2"></th>
          <th className="border p-2">Building</th>
          <th className="border p-2">Caller</th>
          <th className="border p-2">Type</th>
          <th className="border p-2">Actions</th>
        </tr>
      </thead>
      <tbody>
        {callLogs.map((log) => (
          <tr key={log.callNumber} className={"border-t cursor-pointer" + (selectedLog === log?.callNumber ? " bg-gray-100" : "")}
            onClick={() => {
              if (selectedLog === log?.callNumber) {
                setSelectedLog(null);
              } else {
                setSelectedLog(log.callNumber);
              }
            }}>
            <td className="border p-2">
              <input type="radio" name="select" value={log.callNumber} checked={selectedLog === log?.callNumber} id={"row" + log.callNumber} />
            </td>
            <td className="border p-2">{log.building?.buildingReference}</td>
            <td className="border p-2">{log.caller?.contactName} - {log.caller?.phone1 || log.caller?.phone2 || log.caller?.cellPhone || log.caller?.cellPhone2}</td>

            <td className="border p-2">{log.type}</td>
            <td className="border p-2 flex flex-col justify-center">
              <button className="text-blue-500" onClick={() => onEdit(log)}>Edit</button>
              {log.status === "Completed" && <button className="text-red-500 ml-2" onClick={() => onFollowUp(log)}>Follow Up</button>}
            </td>
          </tr>
        ))}
      </tbody>

    </table>
  );
};

export default CallLogsTable;